import React, { useEffect, useRef, useState, useCallback } from "react";
import
{
  Container,
  Button,
  UncontrolledTooltip,
  Input,
  DropdownToggle,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Row,
  Col,
  Card,
  CardBody,
  UncontrolledDropdown,
  Form,
  FormFeedback,
} from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import SimpleBar from "simplebar-react";
import Picker from "emoji-picker-react";
import { isEmpty, map } from "lodash";
import PropTypes from "prop-types";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";

//Import Icons
import FeatherIcon from "feather-icons-react";
// import PersonalInfo from "./PersonalInfo";

//redux
import { useSelector, useDispatch } from "react-redux";

import { getAlertes as onGetAlerte } from "../../../store/actions";

import avatar2 from "../../../assets/images/users/avatar-2.jpg";
import userDummayImage from "../../../assets/images/users/user-dummy-img.jpg";

//Import Scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import ShowAlerte from "../../../Components/Common/ShowAlerte";
import { lireRoleSession } from "../../../espace";

const Alertes = ( props ) =>
{
  const ref = useRef();
  const dispatch = useDispatch();
  const [ show_info, setshow_info ] = useState( false );
  const [ alerteSelected, setalerteSelected ] = useState( "" );
  const [ Chat_Box_Categorie, setChat_Box_Categorie ] = useState( null );

  function formatDate ( date )
  {
    const dateObject = new Date( date ).toLocaleDateString( "fr-FR", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
    } );
    return dateObject;
  }

  const [ roleSession, setRoleSession ] = useState( lireRoleSession )
  const [ idConnected, setIdConnected ] = useState( null )
  function getSessionData ()
  {
    if ( localStorage.getItem( "authUser" ) )
    {
      const obj = JSON.parse( localStorage.getItem( "authUser" ) );
      // console.log( 'obj localStorage:', obj )
      setRoleSession( obj.role )

      if ( obj.data )
      {
        setIdConnected( obj.data.id )
      }
    }
  }

  useEffect( () =>
  {
    getSessionData()
  }, [] );

  useEffect( () =>
  {
    if ( roleSession === "ORGANISATEUR" )
    {
      userChatOpen( "Organisateur" )
    }
  }, [ roleSession ] )

  const [ Chat_Box_Image, setChat_Box_Image ] = useState( avatar2 );
  const [ currentRoomId, setCurrentRoomId ] = useState( 1 );
  const [ messageBox, setMessageBox ] = useState( null );

  const [ search_Menu, setsearch_Menu ] = useState( false );

  const [ settings_Menu, setsettings_Menu ] = useState( false );

  const { alertes, isAlerteSuccess, error } = useSelector( ( state ) => ( {
    alertes: state.Alerte.alertes,
    isAlerteSuccess: state.Alerte.isAlerteSuccess,
    error: state.Alerte.error,
  } ) );

  //Toggle Chat Box Menus
  const toggleSearch = () =>
  {
    setsearch_Menu( !search_Menu );
  };

  //Info details offcanvas
  const toggleInfo = ( categorie ) =>
  {
    setshow_info( !show_info );
    // console.log("categorie: ", categorie);
    // if (categorie === "Conducteur") {
    // }
  };

  const toggleSettings = () =>
  {
    setsettings_Menu( !settings_Menu );
  };
  useEffect( () =>
  {
    dispatch( onGetAlerte() );
    // console.log("Alertes: ", alertes);
  }, [ dispatch, Chat_Box_Categorie ] );

  const filterAlertes = ( categorie ) =>
  {
    let alerteSelected = alertes.data
      ? alertes.data.filter( ( alerte ) => alerte.categorie === categorie )
      : [];
    return alerteSelected;
  };

  let categories = [
    {
      name: "Clients",
      value: "Client",
      unReadMessage: "",
    },
    {
      name: "Conducteurs",
      value: "Conducteur",
      unReadMessage: "",
    },
    {
      name: "Conducteurs Voiture",
      value: "ConducteurVoiture",
      unReadMessage: "",
    },
    {
      name: "Conducteurs Moto",
      value: "ConducteurMoto",
      unReadMessage: "",
    },
    {
      name: "Livreurs",
      value: "Livreur",
      unReadMessage: "",
    },
    {
      name: "Organisateurs",
      value: "Organisateur",
      unReadMessage: "",
    },
  ];

  // useEffect(() => {
  //   ref.current.recalculate();
  // });

  //Use For Chat Box
  const userChatOpen = ( category ) =>
  {
    setChat_Box_Categorie( category );
    const listfiltered = filterAlertes( category );
    setalerteSelected( listfiltered );
    validation.resetForm();
    dispatch( onGetAlerte() );
  };

  const scrollToBottom = useCallback( () =>
  {
    if ( messageBox )
    {
      messageBox.scrollTop = messageBox.scrollHeight + 1000;
    }
  }, [ messageBox ] );

  useEffect( () =>
  {
    if ( !isEmpty( alertes ) )
    {
      scrollToBottom();
      const listfiltered = filterAlertes( Chat_Box_Categorie );
      setalerteSelected( listfiltered );
    }
  }, [ alertes, scrollToBottom ] );

  //serach recent user
  const searchUsers = () =>
  {
    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById( "search-user" );
    filter = input.value.toUpperCase();
    var userList = document.getElementsByClassName( "users-list" );
    Array.prototype.forEach.call( userList, function ( el )
    {
      li = el.getElementsByTagName( "li" );
      for ( i = 0; i < li.length; i++ )
      {
        a = li[ i ].getElementsByTagName( "a" )[ 0 ];
        txtValue = a.textContent || a.innerText;
        if ( txtValue.toUpperCase().indexOf( filter ) > -1 )
        {
          li[ i ].style.display = "";
        } else
        {
          li[ i ].style.display = "none";
        }
      }
    } );
  };

  //Search Message
  const searchMessages = () =>
  {
    var searchInput, searchFilter, searchUL, searchLI, a, i, txtValue;
    searchInput = document.getElementById( "searchMessage" );
    searchFilter = searchInput.value.toUpperCase();
    searchUL = document.getElementById( "users-conversation" );
    searchLI = searchUL.getElementsByTagName( "li" );
    Array.prototype.forEach.call( searchLI, function ( search )
    {
      a = search.getElementsByTagName( "p" )[ 0 ]
        ? search.getElementsByTagName( "p" )[ 0 ]
        : "";
      txtValue =
        a.textContent || a.innerText ? a.textContent || a.innerText : "";
      if ( txtValue.toUpperCase().indexOf( searchFilter ) > -1 )
      {
        search.style.display = "";
      } else
      {
        search.style.display = "none";
      }
    } );
  };

  // Copy Message
  const handleCkick = ( ele ) =>
  {
    var copy = ele
      .closest( ".chat-list" )
      .querySelector( ".ctext-content" ).innerHTML;
    navigator.clipboard.writeText( copy );

    document.getElementById( "copyClipBoard" ).style.display = "block";
    setTimeout( () =>
    {
      document.getElementById( "copyClipBoard" ).style.display = "none";
    }, 2000 );
  };

  // emoji
  const [ emojiArray, setemojiArray ] = useState( "" );

  // const onEmojiClick = (event, emojiObject) => {
  //   setemojiArray([...emojiArray, emojiObject.emoji]);
  //   let emoji = [...emojiArray, emojiObject.emoji].join(" ");
  //   // setcurMessage(emoji);
  // };

  // validation
  const validation = useFormik( {
    enableReinitialize: true,
    initialValues: {
      titre: "",
      content: "",
    },
    validationSchema: Yup.object( {
      titre: Yup.string().required( props.t( "Veuillez renseigner le titre" ) ),
      content: Yup.string().required(
        props.t( "Veuillez renseigner le contenu du message" )
      ),
    } ),
    onSubmit: ( values ) =>
    {
      const addMessage = {
        categorie: Chat_Box_Categorie,
        titre: values.titre,
        content: values.content,
      };

      console.log( "addMessage:", addMessage );

      try
      {
        axiosInstance
          .post( `/notificationadmin/`, addMessage )
          .then( ( response ) =>
          {
            validation.resetForm();
            toast.success( props.t( "Alerte envoyée avec succès" ), {
              autoClose: 3000,
            } );
            validation.resetForm();
            dispatch( onGetAlerte() );
          } )
          .catch( ( error ) =>
          {
            // console.error(error);
            toast.error( props.t( "Echec de l'envoi de l'alerte" ), {
              autoClose: 3000,
            } );
          } );
      } catch ( err )
      {
        console.error( err );
        toast.error( props.t( "Echec de l'envoi de l'alerte" ), {
          autoClose: 2000,
        } );
      }
      dispatch( onGetAlerte() );
    },
  } );

  document.title = "Alertes || Takci";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Alertes" ) } pageTitle="Takci" />
          <div className="chat-wrapper d-flex gap-1 mx-n4 mt-n4 p-1">
            {
              roleSession !== "ORGANISATEUR" &&
              <div
                className={ `chat-leftsidebar ${ Chat_Box_Categorie && "d-none d-lg-block"
                  }` }
              >
                <div className="px-4 pt-4 mb-4">
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1">
                      <h5 className="mb-4">Catégories</h5>
                    </div>
                    {/* <div className="flex-shrink-0">
                    <UncontrolledTooltip placement="bottom" target="addcontact">
                      Add Contact
                    </UncontrolledTooltip>

                    <Button
                      color=""
                      id="addcontact"
                      className="btn btn-soft-success btn-sm"
                    >
                      <i className="ri-add-line align-bottom"></i>
                    </Button>
                  </div> */}
                  </div>
                  <div className="search-box">
                    <input
                      onKeyUp={ searchUsers }
                      id="search-user"
                      type="text"
                      className="form-control bg-light border-light"
                      placeholder="Search here..."
                    />
                    <i className="ri-search-2-line search-icon"></i>
                  </div>
                </div>

                <SimpleBar className="chat-room-list">
                  {/* <div className="d-flex align-items-center px-4 mb-2">
                  <div className="flex-grow-1">
                    <h4 className="mb-0 fs-11 text-muted text-uppercase">
                      Direct Messages
                    </h4>
                  </div>
                  <div className="flex-shrink-0">
                    <UncontrolledTooltip placement="bottom" target="addnewmsg">
                      New Message
                    </UncontrolledTooltip>

                    <button
                      type="button"
                      id="addnewmsg"
                      className="btn btn-soft-success btn-sm"
                    >
                      <i className="ri-add-line align-bottom"></i>
                    </button>
                  </div>
                </div> */}

                  {/* <div className="chat-message-list">
                  <ul
                    className="list-unstyled chat-list chat-user-list users-list"
                    id="userList"
                  >
                    {(chats || []).map((chat) => (
                      <li
                        key={chat.id + chat.status}
                        className={
                          currentRoomId === chat.roomId ? "active" : ""
                        }
                      >
                        <Link
                          to="#"
                          onClick={(e) => {
                            userChatOpen(
                              chat.id,
                              chat.name,
                              chat.status,
                              chat.roomId,
                              chat.image
                            );
                          }}
                        >
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 chat-user-img online align-self-center me-2 ms-0">
                              <div className="avatar-xxs">
                                {chat.image ? (
                                  <img
                                    src={chat.image}
                                    className="rounded-circle img-fluid userprofile"
                                    alt=""
                                  />
                                ) : (
                                  <div
                                    className={
                                      "avatar-title rounded-circle bg-" +
                                      chat.bgColor +
                                      " userprofile"
                                    }
                                  >
                                    {chat.name.charAt(0)}
                                  </div>
                                )}
                              </div>
                              <span className="user-status"></span>
                            </div>
                            <div className="flex-grow-1 overflow-hidden">
                              <p className="text-truncate mb-0">{chat.name}</p>
                            </div>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div> */}

                  {/* <div className="d-flex align-items-center px-4 mt-4 pt-2 mb-2">
                  <div className="flex-grow-1">
                    <h4 className="mb-0 fs-11 text-muted text-uppercase">
                      Catégories
                    </h4>
                  </div>
                </div> */}

                  <div className="chat-message-list">
                    <ul
                      className="list-unstyled chat-list chat-user-list mb-0 users-list"
                      id="channelList"
                    >
                      {
                        categories.map( ( category, key ) => (
                          <React.Fragment key={ key }>
                            <li
                              key={ category.value + key }
                              className={
                                Chat_Box_Categorie === category.value
                                  ? "active"
                                  : ""
                              }
                            >
                              <Link
                                to="#"
                                className="unread-msg-user"
                                onClick={ ( e ) =>
                                {
                                  userChatOpen( category.value );
                                } }
                              >
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 chat-user-img online align-self-center me-2 ms-0">
                                    <div className="avatar-xxs">
                                      <div className="avatar-title bg-light rounded-circle text-body">
                                        #
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-truncate mb-0">
                                      { category.name }
                                    </p>
                                  </div>
                                  { category.unReadMessage && (
                                    <div className="flex-shrink-0">
                                      <span className="badge badge-soft-dark rounded p-1">
                                        { category.unReadMessage }
                                      </span>
                                    </div>
                                  ) }
                                </div>
                              </Link>
                            </li>
                          </React.Fragment>
                        ) ) }
                    </ul>
                  </div>
                </SimpleBar>
              </div>
            }

            { Chat_Box_Categorie && (
              <div
                className={ `${ Chat_Box_Categorie ? "user-chat-show" : "user-chat"
                  }  w-100 overflow-hidden` }
              >
                <div className="chat-content d-flex">
                  <div className="w-100 overflow-hidden position-relative">
                    <div className="position-relative">
                      <div className="p-3 user-chat-topbar">
                        <Row className="align-items-center">
                          {
                            roleSession !== "ORGANISATEUR" &&
                            <Col sm={ 4 } xs={ 8 }>
                              <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 d-block d-lg-none me-3">
                                  <Link
                                    to="#"
                                    className="user-chat-remove fs-18 p-1"
                                    onClick={ ( e ) =>
                                    {
                                      e.preventDefault();
                                      setChat_Box_Categorie( null );
                                    } }
                                  >
                                    <i className="ri-arrow-left-s-line align-bottom"></i>
                                  </Link>
                                </div>
                                <div className="flex-grow-1 overflow-hidden">
                                  <div className="d-flex align-items-center">
                                    <div className="flex-grow-1 overflow-hidden">
                                      <h5 className="text-truncate mb-0 fs-16">
                                        <a
                                          className="text-reset username"
                                          data-bs-toggle="offcanvas"
                                          href="#userProfileCanvasExample"
                                          aria-controls="userProfileCanvasExample"
                                        >
                                          { Chat_Box_Categorie }
                                        </a>
                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          }

                          <Col sm={ roleSession === "ORGANISATEUR" ? 12 : 8 } xs={ roleSession === "ORGANISATEUR" ? 12 : 4 }>
                            <ul className="list-inline user-chat-nav text-end mb-0">
                              <li className="list-inline-item m-0">
                                <Dropdown
                                  isOpen={ search_Menu }
                                  toggle={ toggleSearch }
                                >
                                  <DropdownToggle
                                    className="btn btn-ghost-secondary btn-icon"
                                    tag="button"
                                  >
                                    <FeatherIcon
                                      icon="search"
                                      className="icon-sm"
                                    />
                                  </DropdownToggle>
                                  <DropdownMenu className="p-0 dropdown-menu-end dropdown-menu-lg">
                                    <div className="p-2">
                                      <div className="search-box">
                                        <Input
                                          onKeyUp={ searchMessages }
                                          type="text"
                                          className="form-control bg-light border-light"
                                          placeholder="Recherche..."
                                          id="searchMessage"
                                        />
                                        <i className="ri-search-2-line search-icon"></i>
                                      </div>
                                    </div>
                                  </DropdownMenu>
                                </Dropdown>
                              </li>

                              {/* <li className="list-inline-item m-0">
                                <Dropdown
                                  isOpen={ show_info }
                                  toggle={ () => toggleInfo( Chat_Box_Categorie ) }
                                >
                                  <DropdownToggle
                                    className="btn btn-ghost-secondary btn-icon"
                                    tag="button"
                                  >
                                    <FeatherIcon
                                      icon="info"
                                      className="icon-sm"
                                    />
                                  </DropdownToggle>
                                  <DropdownMenu className="p-0 dropdown-menu-end dropdown-menu-lg">
                                    <div className="p-2">
                                      <div className="text-center my-3">
                                        <Loader style={ { color: "#014c94" } } />
                                        <h2>Chargement...</h2>
                                      </div>
                                    </div>
                                  </DropdownMenu>
                                </Dropdown>
                              </li> */}
                            </ul>
                          </Col>
                        </Row>
                      </div>

                      <div className="position-relative" id="users-chat">
                        <PerfectScrollbar
                          className="chat-conversation p-3 p-lg-4"
                          id="chat-conversation"
                          style={ {
                            height: "calc(100vh - 104px - 89px - 106px)",
                          } }
                          containerRef={ ( ref ) => setMessageBox( ref ) }
                        >
                          <ShowAlerte alerteSelected={ alerteSelected } />
                        </PerfectScrollbar>
                        <div
                          className="alert alert-warning alert-dismissible copyclipboard-alert px-4 fade show "
                          id="copyClipBoard"
                          role="alert"
                        >
                          Message copié
                        </div>
                      </div>

                      { roleSession !== "ORGANISATEUR" &&
                        <div className="chat-input-section p-3 p-lg-4">
                          <Form
                            id="chatinput-form"
                            onSubmit={ ( e ) =>
                            {
                              e.preventDefault();
                              validation.handleSubmit();
                              return false;
                            } }
                          >
                            <Row className="g-1 align-items-center">
                              <Row className="col-11 g-1">
                                <div className="col-4">
                                  <div className="chat-input-feedback">
                                    Titre de l'alerte...
                                  </div>
                                  <Input
                                    type="text"
                                    className="form-control chat-input bg-light border-light"
                                    id="titre"
                                    placeholder="Titre de l'alerte..."
                                    onChange={ validation.handleChange }
                                    onBlur={ validation.handleBlur }
                                    value={ validation.values.titre }
                                    invalid={
                                      validation.touched.titre &&
                                      validation.errors.titre
                                    }
                                  // onFocus={true}
                                  />
                                  { validation.touched.titre &&
                                    validation.errors.titre ? (
                                    <FormFeedback type="invalid">
                                      { validation.errors.titre }
                                    </FormFeedback>
                                  ) : null }
                                </div>
                                <div className="col-8">
                                  <div className="chat-input-feedback">
                                    Contenu de l'alerte...
                                  </div>
                                  <Input
                                    type="text"
                                    className="form-control chat-input bg-light border-light"
                                    id="content"
                                    placeholder="Contenu de l'alerte..."
                                    onChange={ validation.handleChange }
                                    onBlur={ validation.handleBlur }
                                    value={ validation.values.content }
                                    invalid={
                                      validation.touched.content &&
                                      validation.errors.content
                                    }
                                  />
                                  { validation.touched.content &&
                                    validation.errors.content ? (
                                    <FormFeedback type="invalid">
                                      { validation.errors.content }
                                    </FormFeedback>
                                  ) : null }
                                </div>
                              </Row>
                              <div className="col-1">
                                <div className="chat-input-links ms-2">
                                  <div className="links-list-item">
                                    <Button
                                      type="submit"
                                      style={ { BackgroundColor: "#014c94" } }
                                      // onClick={() => {
                                      //   addMessage(currentRoomId, currentUser.name);
                                      //   setemojiPicker(false);
                                      //   setemojiArray("");
                                      // }}
                                      className="chat-send waves-effect waves-light"
                                    >
                                      <i className="ri-send-plane-2-fill align-bottom"></i>
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </Row>
                          </Form>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            ) }
          </div>
          <ToastContainer closeButton={ false } />
        </Container>
      </div>

      {/* 
        <PersonalInfo
          show={isInfoDetails}
          onCloseClick={() => setIsInfoDetails(false)}
          currentuser={Chat_Box_Username}
          cuurentiseImg={Chat_Box_Image}
        /> 
      */}
    </React.Fragment>
  );
};

Alertes.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( Alertes ) );
